import React, { PureComponent } from 'react';
import { filter, isEmpty, join, map } from 'lodash';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ArrowDropDown, ArrowRight } from '@mui/icons-material';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_REST } from 'js/constants/connectionCategories';

class APISourceConfiguration extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeAcItemKey: 0,
    };

    this._handleAcItemSelected = this._handleAcItemSelected.bind(this);
  }

  render() {
    const { config, dataMapsInUse } = this.props;
    const { activeAcItemKey } = this.state;
    const nonDataMapIterations = filter(
      config['rest.iterations'],
      (iteration) => iteration['iteration.type'] !== 'data.map.key.queue',
    );

    return (
      <div className="api-configuration-view">
        <ConfigurationFields {...this.props} connectionCategory={CONNECTION_CATEGORY_REST} />
        {!isEmpty(dataMapsInUse) && (
          <div className="detail-row">
            <div className="detail-col">
              <div className="detail-key">Lookups in use</div>
              <div className="detail-value">{join(dataMapsInUse, ', ')}</div>
            </div>
          </div>
        )}
        {!isEmpty(nonDataMapIterations) && (
          <div id="iteration-config" className="accordion-group">
            {map(nonDataMapIterations, (iteration, index) => (
              <Accordion
                square
                className="accordion-item"
                expanded={activeAcItemKey === index}
                key={index}
                onChange={() => {
                  this._handleAcItemSelected(index);
                }}
              >
                <AccordionSummary className="accordion-title">
                  <div className="accordion-title-content">
                    <h2>
                      {activeAcItemKey === index ? (
                        <ArrowDropDown fontSize="large" />
                      ) : (
                        <ArrowRight fontSize="large" />
                      )}
                      <span>Step {index + 1}</span>
                    </h2>
                    <div
                      className="accordion-content-grow iteration-info"
                      title={iteration['url.template']}
                    >
                      <span>{iteration['url.template']}</span>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails className="accordion-body">
                  <div className="accordion-body-content">
                    <ConfigurationFields
                      {...this.props}
                      connectionCategory={CONNECTION_CATEGORY_REST}
                      config={iteration}
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        )}
      </div>
    );
  }

  _handleAcItemSelected(acItemKey) {
    const nextKey = acItemKey !== this.state.activeAcItemKey ? acItemKey : null;

    this.setState({ activeAcItemKey: nextKey });
  }
}

export default APISourceConfiguration;
